
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseRadio from "@/components/base/BaseRadio.vue";
import { InsuranceConfirmationEnum } from "@/models/enums";
import { InsuranceConfirmationState } from "@/models/www/store/InsuranceState";
import { useInsuranceStore } from "@/store/insurance";
import { useVuelidate } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	reactive,
	watch,
} from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	components: {
		BaseRadio,
		BaseCheckbox,
	},
	props: {
		type: {
			type: Number as PropType<InsuranceConfirmationEnum>,
			required: true,
		},
		secondType: {
			type: Number as PropType<InsuranceConfirmationEnum>,
			required: false,
		},
	},
	setup(props) {
		const insuranceStore = useInsuranceStore();
		const { t } = useI18n();

		const isCheckbox = [
			InsuranceConfirmationEnum.MedicalCondition,
			InsuranceConfirmationEnum.ForbiddenActivityConfirm,
		].includes(props.type);

		const confirmInput = computed({
			get(): boolean | undefined {
				const confirmInsurance = insuranceStore.getConfirmations.find(
					(c) => c.type === props.type
				);
				if (confirmInsurance) {
					return confirmInsurance.value;
				}

				return undefined;
			},
			set(value: boolean | undefined) {
				insuranceStore.setConfirmation({
					type: props.type,
					value: value,
				} as InsuranceConfirmationState);
			},
		});

		const isValid = () => {
			const confirmInsurance = insuranceStore.getConfirmations.find(
				(c) => c.type === props.type
			);

			if (props?.type === InsuranceConfirmationEnum.ForbiddenActivity) {
				return true;
			}

			const isConfirmNoField = [
				InsuranceConfirmationEnum.DuplicateCover,
			].includes(confirmInsurance?.type as InsuranceConfirmationEnum);

			if (confirmInsurance && isConfirmNoField) {
				return confirmInsurance.value === false ? true : false;
			}

			return confirmInput.value;
		};

		const state = reactive({
			confirmed: confirmInput.value,
		});

		const rules = {
			confirmed: {
				v: helpers.withMessage(
					() =>
						t(`validation.insurance.${InsuranceConfirmationEnum[props.type]}`),
					isValid as any
				),
			},
		};

		const v$ = useVuelidate(rules, state);

		watch(confirmInput, () => {
			v$.value.$touch();
		});

		return {
			confirmInput,
			InsuranceConfirmationEnum,
			v$,
			isCheckbox,
		};
	},
});
